export default {
  'review.charges': 'Charges',
  'review.purpose': 'Purpose of Wire',
  'review.reminder': 'Review and submit to complete payment',
  'review.title': 'Review Payment',
  'review.tranfer': 'Transfer',
  'review.address.lin1': 'Address Line 1',
  'review.address.lin2': 'Address Line 2',
  'review.address.lin3': 'Address Line 3',
  'review.bank.code': 'Bank Code',
  'review.bank.name': 'Bank of New Hampshire',
  'review.bank.routing': 'Bank Code/Name',
  'review.bank.codeType': 'Bank Code Type',
  'review.beneficiary.title': 'Beneficiary information',
  'review.entered.on': 'Entered on',
  'review.line.nr': 'Line <%=nr%>',
  'review.modal.message': 'Are you sure you want to discard this payment?',
  'review.originator.title': 'Originator information',
  'review.payment.type': 'Wire - Domestic'
};
